export default __webpack_public_path__ + "static/media/pipeUp1.d354aa87.png";